import axios from 'axios';
import { LANGUAGE_ENTITY_URL } from 'Constants';
import { LanguageEntity } from '../../../Models/Entities';

export async function getAllLanguages(): Promise<LanguageEntity[]> {
	const response = await axios.get(`${LANGUAGE_ENTITY_URL}/get-all-languages`);
	return response.data as LanguageEntity[];
}
